import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PartService, PlantService } from '../../../phf.service';
import { PartListService } from '../part-list.service';
import { ToMetricPipe } from '../../../../../shared/pipes/common.pipe';
import { BaseService } from '../../../../mesc/mesc.service';
import { FilterableService } from '../../../../mesc/filterable-service';
import { PartDetailService } from '../part-detail/part-detail.service';
import { AuthenticationService } from '../../../../../auth.service';

const CalculationEditForm = {
    Assembly: [],
    Assist: [],
    AssignedTrucks: [],
    Code: [],
    ContainerHeight: [],
    ContainerId: [],
    ContainerLength: [],
    ContainerNumber: [],
    ContainerPrimaryProjectNumber: [],
    ContainerWidth: [],
    ContainersPerTrip: [],
    EquipmentRestriction: [],
    HandlingMax: [],
    HandlingTarget: [],
    Id: [],
    ImageTeamcenterURL: [],
    IsActive: [],
    LoadSideId: [],
    LoadSideName: [],
    MakeBuyId: [],
    ManualDunnage: [],
    ManualSorting: [],
    MaterialId: [],
    Name: [],
    Number: [],
    NumberPeopleLoading: [],
    NumberPeopleSorting: [],
    OrientationCheck: [],
    OverallHandlingSPMICR:[],
    ErgoSPM: [],
    PartHandlingId: [],
    PartsPerContainer: [],
    PartsPerLift: [],
    PartsPerStroke: [],
    PeoplePerLift: [],
    PitchLength: [],
    PlantId: [],
    PlantName: [],
    PresentationId: [],
    PressClass: [],
    PressId: [],
    PressNumber: [],
    PressType: [],
    PressTarget: [],
    ProgramId: [],
    RoboticLoading: [],
    SPMDeviation: [],
    SortingDisplacement: [],
    SystemMax:[],
    TargetSPM: [],
    Thickness: [],
    Throughput: [],
    ToolSetId: [],
    DieAndSystemSPMRestriction: [],
    TravelTime: [],
    TruckAccess: [],
    TruckMax: [],
    TruckTarget: [],
    WalkDistance: [],
    Weight: [],
    Width: [],
    AutoRacking: [],
}
@Component({
    selector: 'calculation',
    templateUrl: './calculation.component.html',
    styleUrls: ['./calculation.component.scss']
})
export class CalculationComponent implements OnInit {
    show = false;
    editForm: FormGroup;
    isLoading = false;
    sideService: FilterableService;
    private isToolSetPart: boolean;
    pdfExportFileName = `calculation_${new Date().toISOString()}.pdf`;
    
    // Get Press info for the system max from the partdetail service
    constructor(
        private readonly partlistService: PartListService,
        private readonly partDetailService: PartDetailService,
        private readonly formBuilder: FormBuilder,
        private readonly partService: PartService,
        private readonly plantService: PlantService,
        private readonly baseService: BaseService,
        private readonly authService: AuthenticationService
        ) { }
        
        ngOnInit() {
            this.isLoading = true;
            this.editForm = this.formBuilder.group(CalculationEditForm);
            this.sideService = this.partlistService.lookupData.SideViewDto;
            
            this.partlistService.selectedPart
            .subscribe(x => {
                this.show = x !== undefined && x !== null;
                if (x) {
                    if (x.PartId) {
                        this.handleToolSetPartCalculation(x.PartId);
                    } else {
                        if (x.Throughput) {
                            this.baseService.read('PHF/Part/Detail/' + x.Id)
                            .then(p => {
                                this.plantService.read('/' + p.PlantId)
                                .then(plant => {
                                    p.PlantName = plant.Name;
                                    p.LoadSideName = this.sideService.value.find(x => x.Id === p.LoadSideId).Name;
                                    this.editForm.reset(p);
                                    this.handleOverallHandlingSPMICR();
                                });
                            });
                        } else {
                            this.applyOptimization(x);
                            this.onWhatIf();
                        }
                    }
                }
                this.isLoading = false;
            })
            
            
        }
        
        
        /**
        * 
        */
        closeForm = () => {
            this.partlistService.selectedPart.next(null);
            this.editForm.reset();
            if (this.isToolSetPart) {
                this.isToolSetPart = false;
                this.partDetailService.isShowPartDetail.next(true);
            }
        }
        
        isDisabled(): boolean {
            return this.authService.isPHFProgramAdmin || this.baseService.loading.value;
        }
        
        /**
        * 
        */
        onWhatIf() {
            this.isLoading = true;
            this.partService.search(this.editForm.value, '/calculate')
            .then(x => {
                if (x){
                    this.editForm.get('Throughput').setValue(x);
                    this.handleOverallHandlingSPMICR();
                } 
                this.isLoading = false;
            });
        }
        
        
        /**
        * 
        */
        onOptimize() {
            this.partlistService.selectedPart.next(this.editForm.value);
            this.partlistService.isShowOptimization.next(true);
            this.handleOverallHandlingSPMICR();
        }
        
        
        /**
        * 
        */
        getColorClass = (flag): string => {
            return flag === 'G' ? 'cgp-success' :
            flag === 'Y' ? 'secondary-yellow' : 'cgp-red';
        }
        
        /**
        * 
        */
        handleOverallHandlingSPMICR = () => {
            const throughput = this.editForm.get('Throughput').value;
            if(throughput!= null){
                const maxArray = [];
                const containerExchangeSpeed = throughput["ContainerExchangeSpeed"];
                const containerHaulingSpeed = throughput["ContainerHaulingSpeed"];
                const materialSPM = throughput["MaterialSPM"];

                let spm = ""
                if(containerExchangeSpeed != null) maxArray.push(containerExchangeSpeed);
                if(containerHaulingSpeed != null) maxArray.push(containerHaulingSpeed);
                if(materialSPM != null) maxArray.push(materialSPM);

                spm = Math.min(...maxArray).toString();

                this.editForm.get('OverallHandlingSPMICR').setValue(spm);
            }
        }
        
        /**
        * 
        * @param field 
        * @param alt 
        */
        getValue(field: string, alt = '', trueText: string = undefined, falseText: string = undefined): string {
            let value: any = this.editForm.value[field];
            value = value === null || value === undefined ? alt : value.toString();
            
            if (trueText !== null || falseText != null) {
                value = value === 'true' ?
                trueText : value === 'false' ?
                falseText : alt;
            }
            return value;
        }
        
        
        
        onKeyUp = (e) => {
            if (isNaN(e.target.valueAsNumber)) {
                try {
                    e.target.value = parseInt(e.target.value);
                } catch (e) {
                    e.target.value = '';
                }
            }
        }
        
        /**
        * 
        * @param field 
        * @param standardUnit 
        * @param metricUnit 
        */
        getConversion(field: string, standardUnit: string, metricUnit: string): string {
            let standard: number, metric: number;
            const dataItem = this.editForm.value;
            let response = '';
            
            if (dataItem && dataItem[field] !== null) {
                standard = parseFloat(dataItem[field])
                metric = new ToMetricPipe()
                .transform(standard, metricUnit);
                
                response = `${dataItem[field].toFixed(2)} (${standardUnit}) / ${metric.toFixed(2)} (${metricUnit})`;
            }
            
            return response;
        }
        
        
        /**
        * Return Id for Side where Name field in sideService matches the check
        * @param check 
        */
        getSide(check: string): string {
            return this.sideService.value ?
            this.sideService.value.find(s => s.Name.toLowerCase() === check.toLowerCase()).Id : null;
        }
        
        
        /**
        * Apply Optimization values to editform
        * Updated fields under Throughput where applicable
        * @param dataItem 
        */
        private applyOptimization(dataItem: any) {
            const tc = this.editForm.get('Throughput');
            const tcValue = tc.value;
            Object.keys(dataItem).forEach(k => {
                const ctrl = this.editForm.get(k);
                const value = dataItem[k];
                if (ctrl) {
                    ctrl.setValue(value);
                } else {
                    if (tcValue[k]) {
                        tcValue[k] = value;
                    }
                }
            });
            tc.setValue(tcValue);
            this.handleOverallHandlingSPMICR();
        }
        
        
        /**
        * 
        * @param partId 
        */
        private handleToolSetPartCalculation(partId: string) {
            this.isToolSetPart = true;
            this.isLoading = true;
            this.partDetailService.isShowPartDetail.next(false);
            this.partService.read('/detail/' + partId)
            .then(x => {
                this.isLoading = false;
                this.partlistService.selectedPart.next(x);
            });
        }
        
        validateValue(value: any) {
            if (value === null || isNaN(value)) {
                return 'TBD';
            } else if (value === "-1.00") {
                return 'N/A';
            } else {
                return value;
            }
        }

        isAutoRacking(){
            if (this.editForm.get('AutoRacking').value == true) return true;
            return false;
        }

        isLoadingCurrently(): boolean {
            return this.isLoading;
        }
    }
    